import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getTenantDetail = async (id) => {
  try {
    if (!id) {
      return;
    }
    const resp = await apiClient.get(`/tenant/showTenantDettails/${id}`);
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
